import { HISTORICAL_MODULE_TABLE_TRANSLATION } from './table';
import { HISTORICAL_MODULE_FIELD_TRANSLATION } from './field';
import { HISTORICAL_MODULE_TAB_TRANSLATION } from './tab';
export const HISTORICAL_MODULE_TRANSLATION = {
    ...HISTORICAL_MODULE_TABLE_TRANSLATION,
    ...HISTORICAL_MODULE_FIELD_TRANSLATION,
    ...HISTORICAL_MODULE_TAB_TRANSLATION
};
